module.exports = __webpack_public_path__ + "static/media/under-construction.7a7a7e43.svg";